<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qs2tqr/tc-custom/9781439643570.jpg?1700065800807" alt="This image is the cover for the book Huntsville Penitentiary, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Huntsville Penitentiary, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>The state of Texas, home to one of the largest prison systems in the country, opened its first penitentiary in 1849. The Walls Unit in Huntsville was the genesis of a prison system that became the home of notorious convicts and the focus of much debate about incarceration and the death penalty in the United States. The Walls Unit housed gunslinger John Wesley Hardin, members of the Clyde Barrow and Bonnie Parker gang, and infamous drug cartel leader Fred Carrasco. Built using convict labor, the Walls Unit was heralded as a modern approach to incarceration in Texas. The prison dominated the landscape of the town of Huntsville when it was built and remains central to that community today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theresa Jach, Jim Willett
      </h2>
      
      <p class="authorDescription body article">With a PhD in US history, Prof. Theresa R. Jach has done extensive research and writing on Texas prisons. Mining the vast collection of photographs from the Texas Prison Museum in Huntsville, the Texas State Archives and Libraries, the Thomason Room archives at Sam Houston State University, and the Texas Department of Criminal Justice, Professor Jach has gathered a collection of images that tells the story of the Walls Unit and its employees, families, and prisoners. Jim Willett, the director of the Texas Prison Museum, served as warden at the Walls Unit at the time of his retirement.  He worked for the Texas Department of Criminal Justice for 30 years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b2c9290